import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LaptopOtpverifypopupComponent } from '../laptop-otpverifypopup/laptop-otpverifypopup.component';
import { ToastrService } from 'ngx-toastr';
import { LaptopschemeDataComponent } from '../laptopscheme-data/laptopscheme-data.component';
import * as forge from 'node-forge';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-laptopschemepopup',
  templateUrl: './laptopschemepopup.component.html',
  styleUrls: ['./laptopschemepopup.component.scss']
})
export class LaptopschemepopupComponent implements OnInit {
  generalForm: FormGroup;
  page: boolean;
  publicKey: string = `-----BEGIN PUBLIC KEY-----
  MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB4vticl4+Wxvhi39+YL+Ui
vwPHnD+OnzjniUb+U1qeY8VnCvGXjZsZzSq6P3vNPIpnPtlP0xUTeIsOvFzDa8W5
OuV3YIwPChPSA71Ng4+j1BqR8tNTpXNljAyk4HFvhS8TOX/vJ3WletwidzY3SNG1
pYkh1S5rlWHlin42O+uO7k2HG8Sup5hSGz2om3beNVoFHYLchLt+E5YhUGmUj5u1
yB+tpboqGZkWSp+W394BwlJdq6Uoo9GGRUYRfSYgxoHKSjOaEvtmxaEsB7nehOP7
Hj5N7em8bHsLQrtdC4xfkGzJMnR3nCuU80qIH1dcDtK3IfqfSD8wbTUyYlgdKrld
AgMBAAE=
  -----END PUBLIC KEY-----`;
  constructor(private fb: FormBuilder,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<LaptopOtpverifypopupComponent>,
    private toaster: ToastrService,
    private dataService: DataService,

  ) { }

  ngOnInit(): void {
    this.Intialvalition()
  }

  Intialvalition() {
    this.generalForm = this.fb.group({
      aadhaar: ['', [
        Validators.required,
        Validators.minLength(12),
        Validators.maxLength(12)

      ]]
    });


  }
  openUmisLogin(): void {
    window.open('https://stagingtp.tnega.org/auth/login', '_blank');
  }

  addButtonverifyDilaog(value) {
      const dialogRef = this.dialog.open(LaptopOtpverifypopupComponent, {
        autoFocus: false,
        disableClose: true,
        width: "0%",
        height: "0%",
        panelClass: "mat-dialog",
        data: {
          openKey: 1,
          studentResult: value
        }
      });
      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          this.dialogRef.close(true);
        }

      });
  }



  closeAadharPopup(a) {
    debugger
    this.dialogRef.close(a);

  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  getOtpFunc(value) {
    if (this.generalForm.valid) {
      var rsa = forge.pki.publicKeyFromPem(this.publicKey);
      const aadhaarNo = value?.replace(/\s+/g, '')
      var encryptedAadhar = window.btoa(rsa.encrypt(aadhaarNo));
      let data = {
      aadhaarNo:encryptedAadhar,
    }
      this.dataService.getvalidaadharNo(data, true).subscribe(
        (res) => {
          if (!res?.value?.isAlreadyExist) {
            this.addButtonverifyDilaog(value)
          } else {
            this.toaster.error(res?.value?.errorMessage);
          }
        },
      );
    }
    else {
      this.toaster.warning("Please Enter valid Aadhaar number")

    }

  }

}
